"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchAction = exports.SearchElement = void 0;
const class_validator_1 = require("class-validator");
class SearchElement {
}
__decorate([
    class_validator_1.IsOptional()
], SearchElement.prototype, "term", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsOptional()
], SearchElement.prototype, "enums", void 0);
__decorate([
    class_validator_1.IsOptional()
], SearchElement.prototype, "minDate", void 0);
__decorate([
    class_validator_1.IsOptional()
], SearchElement.prototype, "maxDate", void 0);
__decorate([
    class_validator_1.IsNumber(),
    class_validator_1.IsOptional()
], SearchElement.prototype, "minNumber", void 0);
__decorate([
    class_validator_1.IsNumber(),
    class_validator_1.IsOptional()
], SearchElement.prototype, "maxNumber", void 0);
exports.SearchElement = SearchElement;
class SearchAction {
}
__decorate([
    class_validator_1.IsInt(),
    class_validator_1.Min(0),
    class_validator_1.Max(100),
    class_validator_1.IsOptional()
], SearchAction.prototype, "limit", void 0);
__decorate([
    class_validator_1.IsInt(),
    class_validator_1.Min(1),
    class_validator_1.IsOptional()
], SearchAction.prototype, "page", void 0);
__decorate([
    class_validator_1.IsInt(),
    class_validator_1.Min(0),
    class_validator_1.IsOptional()
], SearchAction.prototype, "skip", void 0);
__decorate([
    class_validator_1.IsString(),
    class_validator_1.IsOptional()
], SearchAction.prototype, "sort", void 0);
__decorate([
    class_validator_1.IsObject(),
    class_validator_1.IsOptional()
], SearchAction.prototype, "where", void 0);
__decorate([
    class_validator_1.IsOptional()
], SearchAction.prototype, "search", void 0);
exports.SearchAction = SearchAction;
//# sourceMappingURL=search.action.js.map